<template>
  <div class="page-container">
    <div class="page-header">
      <v-skeleton-loader
        :loading="!flagNav"
        transition="scale-transition"
        max-height="64"
        type="table-heading"
      >
        <v-toolbar :image="SubNavbarBackGround" dark class="header-title text-white">
          <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{ $t("modeldata") }}</v-toolbar-title>
          <v-spacer />
          <div class="d-flex pr-4">
            <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{ today }}</v-toolbar-title>
          </div>
        </v-toolbar>
      </v-skeleton-loader>
    </div>
    <div class="main-card">
      <!-- Action Bar -->
      <div class="action-bar d-flex align-center justify-end">
        <!-- <div class="search-section">
          <v-text-field
            placeholder="Search models..."
            prepend-inner-icon="mdi-magnify"
            variant="outlined"
            density="comfortable"
            hide-details
            class="search-input"
          />
        </div> -->

        <v-btn
          v-if="!isViewOnly"
          id="button-add-modeldata"
          color="primary"
          class="control-btn create-btn"
          variant="elevated"
          size="large"
          prepend-icon="mdi-plus-circle"
          rounded="xl"
          @click="Add()"
        >
          <span class="btn-text">Add Model</span>
        </v-btn>
      </div>

      <!-- Enhanced Data Table -->
      <div class="table-container">
        <v-data-table-server
          :items="listDataModel"
          :headers="headers"
          :items-per-page="options.itemsPerPage"
          :items-length="searchTotalTable"
          v-model:options="options"
          class="modern-table"
          :loading="dialog"
          loading-text="Loading models..."
        >
          <!-- Custom row template -->
          <template v-slot:item="{ item, index }">
            <tr class="table-row">
              <td class="text-center">
                <div>
                  {{ (options.page - 1) * itemsPerPage + (index + 1) }}
                </div>
              </td>
              <td>
                <div class="provider-cell">
                  <div class="provider-icon">
                    <v-icon size="16" :color="getProviderColor(item.provider)">
                      {{ getProviderIcon(item.provider) }}
                    </v-icon>
                  </div>
                  <span class="provider-name">{{ item.provider }}</span>
                </div>
              </td>
              <td>
                <div class="model-display">
                  <span class="model-name">{{ item.modelDisplay }}</span>
                </div>
              </td>
              <td>
                <code>{{ item.modelName }}</code>
              </td>
              <td class="text-center">
                <span>{{ item.apiVersion || "-" }}</span>
              </td>
              <td class="text-center">
                <div
                  class="model-type-badge"
                  :class="getModelTypeClass(item.modelType)"
                >
                  <v-icon size="14" class="mr-1">
                    {{
                      item.modelType === "text_based" ? "mdi-text" : "mdi-image"
                    }}
                  </v-icon>
                  <span style="font-size: 12px">
                    {{
                      item.modelType === "text_based"
                        ? "Text-Based"
                        : "Text-to-Image"
                    }}
                  </span>
                </div>
              </td>
              <td>
                <div class="price-display">
                  <template v-if="item.modelType === 'text_based'">
                    <div class="price-row">
                      <div class="price-item input">
                        <v-icon size="12" color="success"
                          >mdi-arrow-down</v-icon
                        >
                        <span>{{ item.promptPriceUSD }}</span>
                      </div>
                      <div class="price-item output">
                        <v-icon size="12" color="info">mdi-arrow-up</v-icon>
                        <span>{{ item.completionPriceUSD }}</span>
                      </div>
                    </div>
                    <div class="price-unit">per 1K tokens</div>
                  </template>
                  <template v-else>
                    <div class="price-row">
                      <div class="price-item image">
                        <v-icon size="12" color="purple">mdi-image</v-icon>
                        <span>{{ item.imagePriceUSD }}</span>
                      </div>
                    </div>
                    <div class="price-unit">per image</div>
                  </template>
                </div>
              </td>
              <td class="text-center">
                <div class="action-group" style="justify-content: center">
                  <!-- Edit -->
                  <v-btn
                    id="button-edit-modeldata"
                    variant="text"
                    density="comfortable"
                    @click="Edit(item)"
                    class="action-btn edit-btn"
                    icon
                  >
                    <v-icon size="18">{{ isViewOnly ? 'mdi-eye-outline' : 'mdi-pencil-outline' }}</v-icon>
                    <v-tooltip activator="parent" location="top">
                      {{ isViewOnly ? 'View' : 'Edit' }}
                    </v-tooltip>
                  </v-btn>
                  <!-- Custom Divider -->
                  <div v-if="!isViewOnly" class="action-divider"></div>

                  <!-- Delete -->
                  <v-btn
                    v-if="!isViewOnly"
                    id="button-delete-modeldata"
                    variant="text"
                    density="comfortable"
                    @click="Delete(item)"
                    class="action-btn delete-btn"
                    icon
                  >
                    <v-icon size="18">mdi-delete-outline</v-icon>
                    <v-tooltip activator="parent" location="top">
                      Delete
                    </v-tooltip>
                  </v-btn>
                </div>
              </td>
            </tr>
          </template>
        </v-data-table-server>
      </div>
    </div>

    <!-- Modern Add Dialog -->
    <v-dialog
      v-model="AdddialogUser"
      max-width="1000px"
      persistent
      class="modern-dialog"
    >
      <v-card class="dialog-card">
        <!-- Dialog Header -->
        <div class="dialog-header dialog-header-add">
          <div class="header-main">
            <div class="header-icon-container">
              <div class="icon-background">
                <v-icon size="20" color="white">
                  {{ "mdi-plus" }}
                </v-icon>
              </div>
            </div>
            <div class="header-text-content">
              <h2 class="dialog-title">
                {{ "Add New Model" }}
              </h2>
              <p class="dialog-subtitle">
                {{ "Configure a new AI model for your chatbot" }}
              </p>
            </div>
          </div>
          <div class="header-actions">
            <v-btn
              icon
              variant="text"
              size="small"
              @click="Close"
              class="close-button"
            >
              <v-icon color="white" size="20">mdi-close</v-icon>
            </v-btn>
          </div>
        </div>

        <!-- Dialog Content -->
        <div class="dialog-body">
          <v-form ref="addForm" v-model="formValid">
            <!-- Basic Information -->
            <div class="form-section">
              <h3 class="section-title">
                <v-icon size="18" class="mr-2" color="primary"
                  >mdi-information</v-icon
                >
                Basic Information
              </h3>
              <div class="form-grid">
                <v-autocomplete
                  id="add-field-provider-modeldata"
                  v-model="currentProvider"
                  :items="DDProvider"
                  item-title="providerName"
                  item-value="providerName"
                  label="Provider"
                  variant="outlined"
                  density="comfortable"
                  :rules="rules.required"
                  @update:model-value="changeProvider"
                  class="modern-input"
                >
                  <template v-slot:prepend-inner>
                    <v-icon size="16" color="primary">mdi-cloud</v-icon>
                  </template>
                </v-autocomplete>

                <v-autocomplete
                  id="add-field-modeltype-modeldata"
                  v-model="currentModelType"
                  :items="modelTypes"
                  item-title="typeName"
                  item-value="typeValue"
                  label="Model Type"
                  variant="outlined"
                  density="comfortable"
                  :rules="rules.required"
                  class="modern-input"
                >
                  <template v-slot:prepend-inner>
                    <v-icon size="16" color="primary">mdi-shape</v-icon>
                  </template>
                </v-autocomplete>
              </div>
            </div>

            <!-- Model Details -->
            <div class="form-section">
              <h3 class="section-title">
                <v-icon size="18" class="mr-2" color="primary">mdi-cog</v-icon>
                Model Configuration
              </h3>
              <div class="form-grid">
                <v-text-field
                  id="add-field-displayname-modeldata"
                  v-model="currentModelDisplay"
                  label="Display Name"
                  variant="outlined"
                  density="comfortable"
                  :rules="rules.required"
                  class="modern-input"
                >
                  <template v-slot:prepend-inner>
                    <v-icon size="16" color="primary">mdi-label</v-icon>
                  </template>
                </v-text-field>

                <v-text-field
                  id="add-field-modelname-modeldata"
                  v-model="currentModelName"
                  label="Model Name"
                  variant="outlined"
                  density="comfortable"
                  :rules="rules.required"
                  class="modern-input"
                >
                  <template v-slot:prepend-inner>
                    <v-icon size="16" color="primary">mdi-cube</v-icon>
                  </template>
                </v-text-field>
              </div>

              <div class="form-grid">
                <v-text-field
                  id="add-field-currentAPIversion-modeldata"
                  v-model="currentAPIVesion"
                  label="API Version"
                  variant="outlined"
                  density="comfortable"
                  :disabled="currentProvider === 'Other' || currentProvider === 'OpenAI'"
                  :rules="
                    currentProvider === 'Google' || currentProvider === 'OpenAI'
                      ? rules.notRequired
                      : rules.required
                  "
                  class="modern-input"
                >
                  <template v-slot:prepend-inner>
                    <v-icon size="16" color="primary">mdi-code-tags</v-icon>
                  </template>
                </v-text-field>

                <v-text-field
                  id="add-field-currentAPIversion-modeldata"
                  v-model="maxToken"
                  label="Max Token"
                  variant="outlined"
                  density="comfortable"
                  class="modern-input"
                  type="number"
                  min="0"
                  @keydown="preventNegative"
                >
                  <template v-slot:prepend-inner>
                    <v-icon size="16" color="primary">mdi-alpha-t-circle-outline</v-icon>
                  </template>
                </v-text-field>
              </div>

              <!-- Additional fields for Other provider -->
              <div v-if="currentProvider === 'Other'">
                <v-text-field
                  id="add-field-endpointURL-modeldata"
                  v-model="EndPointURL"
                  label="Endpoint URL"
                  variant="outlined"
                  density="comfortable"
                  :rules="rules.required"
                  class="modern-input full-width"
                >
                  <template v-slot:prepend-inner>
                    <v-icon size="16" color="primary">mdi-link</v-icon>
                  </template>
                </v-text-field>
                <div class="form-grid credentials-row">
                  <!-- Authentication Header Name -->
                  <v-text-field
                    id="add-field-authen-header-modeldata"
                    v-model="AuthenHeaderName"
                    label="Authentication Header Name"
                    variant="outlined"
                    density="comfortable"
                    :rules="
                      currentProvider == 'Other'
                        ? rules.required
                        : rules.notRequired
                    "
                    :disabled="currentProvider != 'Other'"
                    clearable
                    class="modern-input"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon size="16" color="primary">mdi-key-link</v-icon>
                    </template>
                    <template v-slot:append-inner>
                      <v-tooltip
                        text="Name of the header used for authentication"
                        location="top"
                      >
                        <template v-slot:activator="{ props }">
                          <v-icon
                            size="16"
                            v-bind="props"
                            color="grey-lighten-1"
                          >
                            mdi-help-circle-outline
                          </v-icon>
                        </template>
                      </v-tooltip>
                    </template>
                  </v-text-field>

                  <!-- API Key -->
                  <v-text-field
                    id="add-field-APIkey-modeldata"
                    v-model="API_Key"
                    label="API Key"
                    variant="outlined"
                    density="comfortable"
                    :type="Show_API_Key ? 'text' : 'password'"
                    :rules="
                      currentProvider == 'Other'
                        ? rules.required
                        : rules.notRequired
                    "
                    class="modern-input"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon size="16" color="primary">mdi-key</v-icon>
                    </template>
                    <template v-slot:append-inner>
                      <v-btn
                        icon
                        variant="text"
                        size="small"
                        @click="Show_API_Key = !Show_API_Key"
                      >
                        <v-icon size="16">{{
                          Show_API_Key ? "mdi-eye" : "mdi-eye-off"
                        }}</v-icon>
                      </v-btn>
                    </template>
                  </v-text-field>
                </div>
              </div>
            </div>

            <!-- Pricing Configuration -->
            <div class="form-section">
              <h3 class="section-title">
                <v-icon size="18" class="mr-2" color="primary"
                  >mdi-currency-usd</v-icon
                >
                Pricing Configuration
              </h3>
              <div
                class="form-grid"
                v-if="currentModelType !== 'text_to_image'"
              >
                <v-text-field
                  id="add-field-InputPrice-modeldata"
                  v-model="CurrentPromptPrice"
                  label="Input Price (USD)"
                  variant="outlined"
                  density="comfortable"
                  type="number"
                  step="0.000001"
                  class="modern-input"
                  :rules="rules.requiredNumber"
                  :error-messages="errorMessage.CurrentPromptPrice.message"
                  :error="errorMessage.CurrentPromptPrice.error"
                >
                  <template v-slot:prepend-inner>
                    <v-icon size="16" color="success">mdi-arrow-down</v-icon>
                  </template>
                  <template v-slot:append-inner>
                    <span class="price-suffix">per 1K tokens</span>
                  </template>
                </v-text-field>

                <v-text-field
                  id="add-field-outputprice-modeldata"
                  v-model="CurrentCompletionPrice"
                  label="Output Price (USD)"
                  variant="outlined"
                  density="comfortable"
                  type="number"
                  step="0.000001"
                  class="modern-input"
                  :rules="rules.requiredNumber"
                  :error-messages="errorMessage.CurrentCompletionPrice.message"
                  :error="errorMessage.CurrentCompletionPrice.error"
                >
                  <template v-slot:prepend-inner>
                    <v-icon size="16" color="info">mdi-arrow-up</v-icon>
                  </template>
                  <template v-slot:append-inner>
                    <span class="price-suffix">per 1K tokens</span>
                  </template>
                </v-text-field>
              </div>

              <div class="form-grid" v-else>
                <v-text-field
                  id="add-field-ImagePrice-modeldata"
                  v-model="CurrentImagePrice"
                  label="Image Price (USD)"
                  variant="outlined"
                  density="comfortable"
                  type="number"
                  step="0.000001"
                  class="modern-input"
                >
                  <template v-slot:prepend-inner>
                    <v-icon size="16" color="purple">mdi-image</v-icon>
                  </template>
                  <template v-slot:append-inner>
                    <span class="price-suffix">per image</span>
                  </template>
                </v-text-field>
              </div>
            </div>

            <!-- Image Options (for text-to-image models) -->
            <transition name="fade-slide">
              <div
                v-if="currentModelType === 'text_to_image'"
                class="form-section"
              >
                <h3 class="section-title">
                  <v-icon size="18" class="mr-2" color="primary"
                    >mdi-image-settings</v-icon
                  >
                  Image Generation Options
                </h3>
                <div class="form-grid">
                  <v-select
                    id="add-field-imageQuality-modeldata"
                    v-model="currentQuality"
                    :items="imageQualityOptions"
                    item-title="text"
                    item-value="value"
                    label="Quality"
                    variant="outlined"
                    density="comfortable"
                    class="modern-input"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon size="16" color="primary">mdi-star</v-icon>
                    </template>
                  </v-select>

                  <v-select
                    id="add-field-Resolution-modeldata"
                    v-model="currentResolution"
                    :items="['1024x1024', '1792x1024', '1024x1792']"
                    label="Resolution"
                    variant="outlined"
                    density="comfortable"
                    class="modern-input"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon size="16" color="primary">mdi-monitor</v-icon>
                    </template>
                  </v-select>
                </div>
              </div>
            </transition>

            <!-- Additional Options -->
            <div class="form-section">
              <h3 class="section-title">
                <v-icon size="18" class="mr-2" color="primary">mdi-tune</v-icon>
                Additional Options
              </h3>
              <div class="switch-grid">
                <div class="switch-item">
                  <v-switch
                    id="add-switch-uploadfile-modeldata"
                    v-model="UseUploadFile"
                    color="primary"
                    inset
                    density="comfortable"
                    hide-details
                  />
                  <div class="switch-content">
                    <div class="switch-title">File Upload Support</div>
                    <div class="switch-description">
                      Allow file uploads with this model
                    </div>
                  </div>
                </div>

                <div class="switch-item">
                  <v-switch
                    id="add-switch-EnacleReasoningEffort-modeldata"
                    v-model="UseReasoningEffort"
                    color="primary"
                    inset
                    density="comfortable"
                    hide-details
                  />
                  <div class="switch-content">
                    <div class="switch-title">Reasoning Effort</div>
                    <div class="switch-description">
                      Enable advanced reasoning capabilities
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- JSON Configuration -->
            <div class="form-section">
              <div
                class="json-header"
                @click="showMoreJSONFormat = !showMoreJSONFormat"
              >
                <h3 class="section-title expandable">
                  <v-icon size="18" class="mr-2" color="primary"
                    >mdi-code-json</v-icon
                  >
                  JSON Configuration
                  <v-icon
                    class="expand-icon"
                    :class="{ expanded: showMoreJSONFormat }"
                  >
                    mdi-chevron-down
                  </v-icon>
                </h3>
              </div>

              <v-expand-transition>
                <div v-show="showMoreJSONFormat">
                  <div class="json-info-card">
                    <h4>System Prompt Format (OpenAI o1+)</h4>
                    <div class="code-example">
                      <pre><code>{
  "messages": {
    "role": "developer"
  },
  "max_completion_tokens": "{max_completion_tokens}",
  "stream": "{stream}"
}</code></pre>
                    </div>
                    <ul class="format-notes">
                      <li>
                        <strong>role:</strong> Specifies system role for better
                        context
                      </li>
                      <li>
                        <strong>max_completion_tokens:</strong> Maximum response
                        length
                      </li>
                      <li>
                        <strong>stream:</strong> Enable streaming responses
                      </li>
                    </ul>
                  </div>

                  <!-- JSON Editor -->
                  

                  <div v-if="!isValidJson(JSON_Format)" class="error-message">
                    <v-icon size="16" color="error" class="mr-2"
                      >mdi-alert-circle</v-icon
                    >
                    Invalid JSON format. Please check your syntax.
                  </div>
                </div>
              </v-expand-transition>
            </div>
          </v-form>

          <div class="json-editor-container">
                    <prism-editor
                      ref="addJsonEditor"
                      v-model="JSON_Format"
                      :highlight="highlighter"
                      :line-numbers="true"
                      class="json-editor"
                      :class="{
                        error:
                          currentProvider === 'Other' &&
                          !isValidJson(JSON_Format),
                      }"
                      @drop="onDrop"
                      @dragover="onDragOver"
                    />

                    <!-- JSON Tools -->
                    <div class="json-tools">
                      <v-menu>
                        <template v-slot:activator="{ props }">
                          <v-btn
                            v-bind="props"
                            variant="elevated"
                            color="primary"
                            size="small"
                            class="json-tool-btn"
                          >
                            <v-icon size="16" class="mr-1">mdi-plus</v-icon>
                            Add Value
                          </v-btn>
                        </template>
                        <v-list class="json-menu">
                          <v-list-item
                            v-for="(item, index) in menuKeyJSON"
                            :key="index"
                            @click="insertTextAtCursor(item.key)"
                            @dragstart="onDragStart($event, item.key)"
                            draggable="true"
                            class="json-menu-item draggable-item"
                          >
                            <v-list-item-title>{{
                              item.display
                            }}</v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </div>
                  </div>
        </div>

        <v-divider />

        <!-- Dialog Actions -->
        <div class="dialog-actions">
          <v-btn variant="outlined" @click="Close" class="dialog-action-btn cancel-btn">
            Cancel
          </v-btn>
          <v-btn
            v-if="!isViewOnly"
            id="add-button-save-modeldata"
            variant="elevated"
            color="primary"
            @click="AddModelData"
            :loading="dialog"
            class="dialog-action-btn save-btn-add"
          >
            <v-icon size="16" class="mr-2">mdi-plus</v-icon>
            Add Model
          </v-btn>
        </div>
      </v-card>
    </v-dialog>

    <!-- Edit Dialog (similar structure) -->
    <!-- Edit Dialog -->
    <v-dialog
      v-model="EditdialogUser"
      max-width="1000px"
      persistent
      class="modern-dialog"
    >
      <v-card class="dialog-card">
        <div class="dialog-header dialog-header-edit">
          <div class="header-main">
            <div class="header-icon-container">
              <div class="icon-background">
                <v-icon size="20" color="white"> mdi-pencil-circle </v-icon>
              </div>
            </div>
            <div class="header-text-content">
              <h2 class="dialog-title">
                {{ $t("editnewmodel") }}
              </h2>
              <p class="dialog-subtitle">
                {{ "Update model configuration and settings" }}
              </p>
            </div>
          </div>
          <div class="header-actions">
            <v-btn
              icon
              variant="text"
              size="small"
              @click="Close"
              class="close-button"
              color="white"
            >
              <v-icon size="20">mdi-close</v-icon>
            </v-btn>
          </div>
        </div>
        
        <!-- Dialog Content -->
        <div class="dialog-body">
          <v-form ref="editForm">
            <!-- Basic Information -->
            <div class="form-section">
              <h3 class="section-title">
                <v-icon size="18" class="mr-2" color="primary"
                  >mdi-information</v-icon
                >
                Basic Information
              </h3>
              <div class="form-grid">
                <v-autocomplete
                  id="edit-field-provider-modeldata"
                  v-model="currentProvider"
                  :items="DDProvider"
                  item-title="providerName"
                  item-value="providerName"
                  label="Provider"
                  variant="outlined"
                  density="comfortable"
                  :rules="rules.required"
                  @update:model-value="changeProvider"
                  class="modern-input"
                >
                  <template v-slot:prepend-inner>
                    <v-icon size="16" color="primary">mdi-cloud</v-icon>
                  </template>
                  <template v-slot:append-inner>
                    <v-tooltip text="Select the AI provider" location="top">
                      <template v-slot:activator="{ props }">
                        <v-icon size="16" v-bind="props" color="grey-lighten-1">
                          mdi-help-circle-outline
                        </v-icon>
                      </template>
                    </v-tooltip>
                  </template>
                </v-autocomplete>

                <v-autocomplete
                  id="edit-field-modeltye-modeldata"
                  v-model="currentModelType"
                  :items="modelTypes"
                  item-title="typeName"
                  item-value="typeValue"
                  label="Model Type"
                  variant="outlined"
                  density="comfortable"
                  :rules="rules.required"
                  class="modern-input"
                >
                  <template v-slot:prepend-inner>
                    <v-icon size="16" color="primary">mdi-shape</v-icon>
                  </template>
                  <template v-slot:append-inner>
                    <v-tooltip text="Choose model type" location="top">
                      <template v-slot:activator="{ props }">
                        <v-icon size="16" v-bind="props" color="grey-lighten-1">
                          mdi-help-circle-outline
                        </v-icon>
                      </template>
                    </v-tooltip>
                  </template>
                </v-autocomplete>
              </div>
            </div>

            <!-- Model Details -->
            <div class="form-section">
              <h3 class="section-title">
                <v-icon size="18" class="mr-2" color="primary">mdi-cog</v-icon>
                Model Configuration
              </h3>
              <div class="form-grid">
                <v-text-field
                  id="edit-field-modeldisplay-modeldata"
                  v-model="currentModelDisplay"
                  label="Display Name"
                  variant="outlined"
                  density="comfortable"
                  :rules="rules.required"
                  class="modern-input"
                >
                  <template v-slot:prepend-inner>
                    <v-icon size="16" color="primary">mdi-label</v-icon>
                  </template>
                  <template v-slot:append-inner>
                    <v-tooltip text="Friendly name for display" location="top">
                      <template v-slot:activator="{ props }">
                        <v-icon size="16" v-bind="props" color="grey-lighten-1">
                          mdi-help-circle-outline
                        </v-icon>
                      </template>
                    </v-tooltip>
                  </template>
                </v-text-field>

                <v-text-field
                  id="edit-field-modelname-modeldata"
                  v-model="currentModelName"
                  label="Model Name"
                  variant="outlined"
                  density="comfortable"
                  :rules="rules.required"
                  class="modern-input"
                >
                  <template v-slot:prepend-inner>
                    <v-icon size="16" color="primary">mdi-cube</v-icon>
                  </template>
                  <template v-slot:append-inner>
                    <v-tooltip :text="$t('_InfoModelName')" location="top">
                      <template v-slot:activator="{ props }">
                        <v-icon size="16" v-bind="props" color="grey-lighten-1">
                          mdi-help-circle-outline
                        </v-icon>
                      </template>
                    </v-tooltip>
                  </template>
                </v-text-field>
              </div>

              <div class="form-grid">
                <v-text-field
                  id="edit-field-APIversion-modeldata"
                  v-model="currentAPIVesion"
                  label="API Version"
                  variant="outlined"
                  density="comfortable"
                  :disabled="currentProvider === 'Other' || currentProvider === 'OpenAI'"
                  :rules="
                    currentProvider === 'Google' || currentProvider === 'OpenAI'
                      ? rules.notRequired
                      : rules.required
                  "
                  class="modern-input"
                >
                  <template v-slot:prepend-inner>
                    <v-icon size="16" color="primary">mdi-code-tags</v-icon>
                  </template>
                  <template v-slot:append-inner>
                    <v-tooltip :text="$t('_InfoVersionOfModel')" location="top">
                      <template v-slot:activator="{ props }">
                        <v-icon size="16" v-bind="props" color="grey-lighten-1">
                          mdi-help-circle-outline
                        </v-icon>
                      </template>
                    </v-tooltip>
                  </template>
                </v-text-field>

                <v-text-field
                  id="add-field-currentAPIversion-modeldata"
                  v-model="maxToken"
                  label="Max Token"
                  variant="outlined"
                  density="comfortable"
                  class="modern-input"
                  type="number"
                  min="0"
                  @keydown="preventNegative"
                >
                  <template v-slot:prepend-inner>
                    <!-- change icon -->
                    <v-icon size="16" color="primary">mdi-alpha-t-circle-outline</v-icon>
                  </template>
                </v-text-field>
              </div>

              <!-- Additional fields for Other provider -->
              <transition name="fade-slide">
                <div v-if="currentProvider === 'Other'">
                  <v-text-field
                    id="add-field-endpointURL-modeldata"
                    v-model="EndPointURL"
                    label="Endpoint URL"
                    variant="outlined"
                    density="comfortable"
                    :rules="rules.required"
                    class="modern-input full-width"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon size="16" color="primary">mdi-link</v-icon>
                    </template>
                  </v-text-field>
                  <div class="form-grid credentials-row">
                    <!-- Authentication Header Name -->
                    <v-text-field
                      id="add-field-authen-header-modeldata"
                      v-model="AuthenHeaderName"
                      label="Authentication Header Name"
                      variant="outlined"
                      density="comfortable"
                      :rules="
                        currentProvider == 'Other'
                          ? rules.required
                          : rules.notRequired
                      "
                      :disabled="currentProvider != 'Other'"
                      clearable
                      class="modern-input"
                    >
                      <template v-slot:prepend-inner>
                        <v-icon size="16" color="primary">mdi-key-link</v-icon>
                      </template>
                      <template v-slot:append-inner>
                        <v-tooltip
                          text="Name of the header used for authentication"
                          location="top"
                        >
                          <template v-slot:activator="{ props }">
                            <v-icon
                              size="16"
                              v-bind="props"
                              color="grey-lighten-1"
                            >
                              mdi-help-circle-outline
                            </v-icon>
                          </template>
                        </v-tooltip>
                      </template>
                    </v-text-field>

                    <!-- API Key -->
                    <v-text-field
                      id="add-field-APIkey-modeldata"
                      v-model="API_Key"
                      label="API Key"
                      variant="outlined"
                      density="comfortable"
                      :type="Show_API_Key ? 'text' : 'password'"
                      :rules="
                        currentProvider == 'Other'
                          ? rules.required
                          : rules.notRequired
                      "
                      class="modern-input"
                    >
                      <template v-slot:prepend-inner>
                        <v-icon size="16" color="primary">mdi-key</v-icon>
                      </template>
                      <template v-slot:append-inner>
                        <v-btn
                          icon
                          variant="text"
                          size="small"
                          @click="Show_API_Key = !Show_API_Key"
                        >
                          <v-icon size="16">{{
                            Show_API_Key ? "mdi-eye" : "mdi-eye-off"
                          }}</v-icon>
                        </v-btn>
                      </template>
                    </v-text-field>
                  </div>
                </div>
              </transition>
            </div>

            <!-- Pricing Configuration -->
            <div class="form-section">
              <h3 class="section-title">
                <v-icon size="18" class="mr-2" color="primary"
                  >mdi-currency-usd</v-icon
                >
                Pricing Configuration
              </h3>
              <div
                class="form-grid"
                v-if="currentModelType !== 'text_to_image'"
              >
                <v-text-field
                  id="edit-field-inputprice-modeldata"
                  v-model="CurrentPromptPrice"
                  label="Input Price (USD)"
                  variant="outlined"
                  density="comfortable"
                  type="number"
                  step="0.000001"
                  class="modern-input"
                  :rules="rules.requiredNumber"
                  :error-messages="errorMessage.CurrentPromptPrice.message"
                  :error="errorMessage.CurrentPromptPrice.error"
                >
                  <template v-slot:prepend-inner>
                    <v-icon size="16" color="success">mdi-arrow-down</v-icon>
                  </template>
                  <template v-slot:append-inner>
                    <span class="price-suffix">per 1K tokens</span>
                    <v-tooltip
                      :text="$t('_InfoCurrentPrompPrice')"
                      location="top"
                    >
                      <template v-slot:activator="{ props }">
                        <v-icon
                          size="16"
                          v-bind="props"
                          color="grey-lighten-1"
                          class="ml-2"
                        >
                          mdi-help-circle-outline
                        </v-icon>
                      </template>
                    </v-tooltip>
                  </template>
                </v-text-field>

                <v-text-field
                  id="edit-field-outputprice-modeldata"
                  v-model="CurrentCompletionPrice"
                  label="Output Price (USD)"
                  variant="outlined"
                  density="comfortable"
                  type="number"
                  step="0.000001"
                  class="modern-input"
                  :rules="rules.requiredNumber"
                  :error-messages="errorMessage.CurrentCompletionPrice.message" 
                  :error="errorMessage.CurrentCompletionPrice.error"
                >
                  <template v-slot:prepend-inner>
                    <v-icon size="16" color="info">mdi-arrow-up</v-icon>
                  </template>
                  <template v-slot:append-inner>
                    <span class="price-suffix">per 1K tokens</span>
                    <v-tooltip
                      :text="$t('_InfoCurrentComppletionPrice')"
                      location="top"
                    >
                      <template v-slot:activator="{ props }">
                        <v-icon
                          size="16"
                          v-bind="props"
                          color="grey-lighten-1"
                          class="ml-2"
                        >
                          mdi-help-circle-outline
                        </v-icon>
                      </template>
                    </v-tooltip>
                  </template>
                </v-text-field>
              </div>

              <div class="form-grid" v-else>
                <v-text-field
                  id="edit-field-Imageprice-modeldata"
                  v-model="CurrentImagePrice"
                  label="Image Price (USD)"
                  variant="outlined"
                  density="comfortable"
                  type="number"
                  step="0.000001"
                  class="modern-input"
                >
                  <template v-slot:prepend-inner>
                    <v-icon size="16" color="purple">mdi-image</v-icon>
                  </template>
                  <template v-slot:append-inner>
                    <span class="price-suffix">per image</span>
                    <v-tooltip text="Price per image generation" location="top">
                      <template v-slot:activator="{ props }">
                        <v-icon
                          size="16"
                          v-bind="props"
                          color="grey-lighten-1"
                          class="ml-2"
                        >
                          mdi-help-circle-outline
                        </v-icon>
                      </template>
                    </v-tooltip>
                  </template>
                </v-text-field>
              </div>
            </div>

            <!-- Image Options -->
            <transition name="fade-slide">
              <div
                v-if="currentModelType === 'text_to_image'"
                class="form-section"
              >
                <h3 class="section-title">
                  <v-icon size="18" class="mr-2" color="primary"
                    >mdi-image-settings</v-icon
                  >
                  Image Generation Options
                </h3>
                <div class="form-grid">
                  <v-select
                    id="edit-field-Imagequality-modeldata"
                    v-model="currentQuality"
                    :items="imageQualityOptions"
                    item-title="text"
                    item-value="value"
                    label="Quality"
                    variant="outlined"
                    density="comfortable"
                    class="modern-input"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon size="16" color="primary">mdi-star</v-icon>
                    </template>
                    <template v-slot:append-inner>
                      <v-tooltip text="Choose image quality" location="top">
                        <template v-slot:activator="{ props }">
                          <v-icon
                            size="16"
                            v-bind="props"
                            color="grey-lighten-1"
                          >
                            mdi-help-circle-outline
                          </v-icon>
                        </template>
                      </v-tooltip>
                    </template>
                  </v-select>

                  <v-select
                    id="edit-field-Resolution-modeldata"
                    v-model="currentResolution"
                    :items="['1024x1024', '1792x1024', '1024x1792']"
                    label="Resolution"
                    variant="outlined"
                    density="comfortable"
                    class="modern-input"
                  >
                    <template v-slot:prepend-inner>
                      <v-icon size="16" color="primary">mdi-monitor</v-icon>
                    </template>
                    <template v-slot:append-inner>
                      <v-tooltip text="Select image resolution" location="top">
                        <template v-slot:activator="{ props }">
                          <v-icon
                            size="16"
                            v-bind="props"
                            color="grey-lighten-1"
                          >
                            mdi-help-circle-outline
                          </v-icon>
                        </template>
                      </v-tooltip>
                    </template>
                  </v-select>
                </div>
              </div>
            </transition>

            <!-- Additional Options -->
            <div class="form-section">
              <h3 class="section-title">
                <v-icon size="18" class="mr-2" color="primary">mdi-tune</v-icon>
                Additional Options
              </h3>
              <div class="switch-grid">
                <div class="switch-item">
                  <v-switch
                    id="edit-switch-uploadfile-modeldata"
                    v-model="UseUploadFile"
                    color="primary"
                    inset
                    density="comfortable"
                    hide-details
                  />
                  <div class="switch-content">
                    <div class="switch-title">File Upload Support</div>
                    <div class="switch-description">
                      {{ $t("_UseUploadFile") }}
                    </div>
                  </div>
                  <v-tooltip :text="$t('_UseUploadFile')" location="top">
                    <template v-slot:activator="{ props }">
                      <v-icon size="16" v-bind="props" color="grey-lighten-1">
                        mdi-help-circle-outline
                      </v-icon>
                    </template>
                  </v-tooltip>
                </div>

                <div class="switch-item">
                  <v-switch
                    id="edit-switch-EnableReasoningEffort-modeldata"
                    v-model="UseReasoningEffort"
                    color="primary"
                    inset
                    density="comfortable"
                    hide-details
                  />
                  <div class="switch-content">
                    <div class="switch-title">Reasoning Effort</div>
                    <div class="switch-description">
                      {{ $t("_ReasoningEffort") }}
                    </div>
                  </div>
                  <v-tooltip :text="$t('_ReasoningEffort')" location="top">
                    <template v-slot:activator="{ props }">
                      <v-icon size="16" v-bind="props" color="grey-lighten-1">
                        mdi-help-circle-outline
                      </v-icon>
                    </template>
                  </v-tooltip>
                </div>
              </div>
            </div>

            <!-- JSON Configuration -->
            <div class="form-section">
              <div
                class="json-header"
                @click="showMoreJSONFormat = !showMoreJSONFormat"
              >
                <h3 class="section-title expandable">
                  <v-icon size="18" class="mr-2" color="primary"
                    >mdi-code-json</v-icon
                  >
                  JSON Configuration
                  <v-icon
                    class="expand-icon"
                    :class="{ expanded: showMoreJSONFormat }"
                  >
                    mdi-chevron-down
                  </v-icon>
                </h3>
              </div>

              <v-expand-transition>
                <div v-show="showMoreJSONFormat">
                  <div class="json-info-card">
                    <h4>System Prompt Format (OpenAI o1+)</h4>
                    <div class="code-example">
                      <pre><code>{
  "messages": {
    "role": "developer"
  },
  "max_completion_tokens": "{max_completion_tokens}",
  "stream": "{stream}"
}</code></pre>
                    </div>
                    <ul class="format-notes">
                      <li>
                        <strong>role:</strong> Specifies system role for better
                        context
                      </li>
                      <li>
                        <strong>max_completion_tokens:</strong> Maximum response
                        length
                      </li>
                      <li>
                        <strong>stream:</strong> Enable streaming responses
                      </li>
                    </ul>
                  </div>

                  

                  <div v-if="!isValidJson(JSON_Format)" class="error-message">
                    <v-icon size="16" color="error" class="mr-2"
                      >mdi-alert-circle</v-icon
                    >
                    {{ $t("_WarningJSONFormat") }}
                  </div>
                </div>
              </v-expand-transition>
            </div>

            <div class="json-editor-container">
              <prism-editor
                ref="editJsonEditor"
                id="fleid-jsonFormat-modeldata"
                v-model="JSON_Format"
                :highlight="highlighter"
                :line-numbers="true"
                class="json-editor"
                :class="{
                  error:
                    currentProvider === 'Other' &&
                    !isValidJson(JSON_Format),
                }"
                @drop="onDrop"
                @dragover="onDragOver"
               />

                 <!-- JSON Tools -->
                 <div class="json-tools">
                   <v-menu>
                     <template v-slot:activator="{ props }">
                       <v-btn
                         v-bind="props"
                         variant="elevated"
                         color="primary"
                         size="small"
                         class="json-tool-btn"
                       >
                         <v-icon size="16" class="mr-1">mdi-plus</v-icon>
                         Add Value
                       </v-btn>
                     </template>
                     <v-list class="json-menu">
                       <v-list-item
                         v-for="(item, index) in menuKeyJSON"
                         :key="index"
                         @click="insertTextAtCursor(item.key)"
                         @dragstart="onDragStart($event, item.key)"
                         draggable="true"
                         class="json-menu-item draggable-item"
                       >
                         <v-list-item-title>{{
                           item.display
                         }}</v-list-item-title>
                       </v-list-item>
                     </v-list>
                   </v-menu>
                 </div>
              </div>            
          </v-form>
        </div>

        <v-divider />

        <!-- Dialog Actions -->
        <div class="dialog-actions">
          <v-btn variant="outlined" @click="Close" class="dialog-action-btn cancel-btn">
            {{ $t("close") }}
          </v-btn>
          <v-btn
            v-if="!isViewOnly"
            id="edit-button-save-modeldata"
            variant="elevated"
            @click="UpdateModelData"
            :loading="dialog"
            class="dialog-action-btn save-btn-edit"
          >
            <v-icon size="16" class="mr-2">mdi-content-save</v-icon>
            {{ $t("save") }}
          </v-btn>
        </div>
      </v-card>
    </v-dialog>

    <!-- Loading Overlay -->
    <v-dialog v-model="dialog" persistent width="320">
      <v-card class="loading-card">
        <v-card-text class="text-center py-6">
          <v-progress-circular
            indeterminate
            color="primary"
            size="48"
            class="mb-4"
          ></v-progress-circular>
          <div class="loading-text">Loading...</div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
// import checkPermissionTwo from '@/api/function.js';
import LogTrace from "@/api/function.js";
// import Cookies from 'js-cookie';

import { PrismEditor } from "vue-prism-editor";
import "vue-prism-editor/dist/prismeditor.min.css";
import { highlight, languages } from "prismjs/components/prism-core";
import "prismjs/components/prism-clike";
import "prismjs/components/prism-javascript";
import "prismjs/themes/prism-okaidia.css";
import editImg from "@/assets/edit1.png";
import deleteImg from "@/assets/delete1.png";

export default {
  name: "MasterData",
  inject: ["flagNav","FontColorTitle","SubNavbarBackGround"],
  components: {
    PrismEditor,
  },
  mixins: [LogTrace],
  data() {
    return {
      isDragOver: false,
      dragCounter: 0,
      listDataModel: [],
      imageQualityOptions: [
        { text: "HD", value: "hd" },
        { text: "Standard", value: "standard" },
      ],
      today: null,
      dialog: false,
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [],
      },
      searchTotalTable: 0,
      totalTable: 0,
      itemsPerPage: 10,
      isFirst: true,
      menus: [],
      rules: {
        notRequired: [],
        required: [(value) => !!value || "Required."],
        requiredNumber: [
          (value) => value != 0 || "Required.",
          (value) => !isNaN(value) || "Must be a number.",
        ],
      },
      errorMessage: {
        CurrentPromptPrice: {
          error: false,
          message: ''
        },
        CurrentCompletionPrice: {
          error: false,
          message: ''
        },
        
      },
      images: {
        edit: editImg,
        delete: deleteImg,
      },
      EditdialogUser: false,
      AdddialogUser: false,
      currentModelName: "",
      currentAPIVesion: "",
      maxToken: "",
      currentID: null,
      statusDialog: false,
      statusText: "",
      typeConfirm: "success",
      CurrentPromptPrice: 0,
      CurrentCompletionPrice: 0,
      UseUploadFile: false,
      UseReasoningEffort: false,
      currentModelDisplay: "",
      currentProvider: "",
      promptPriceTHB: 0,
      completionPriceTHB: 0,
      sortBy: [],
      sortDesc: [],
      DDProvider: [],
      currentModelType: "",
      modelTypes: [
        { typeName: "Text-Based", typeId: "1", typeValue: "text_based" },
        { typeName: "Text-to-Image", typeId: "2", typeValue: "text_to_image" },
      ],
      // New data properties for Text-to-image models
      CurrentImagePrice: 0,
      currentQuality: "", // Options: "HD" or "Standard"
      currentResolution: "", // Options: "1024x1024", "1792x1024", "1024x1792"
      JSON_Format: "",
      lineNumbers: true,
      menuKeyJSON: [],
      JSONFormatAddStatus: false,
      JSONFormatEditStatus: false,
      showMoreJSONFormat: false,
      EndPointURL: null,
      API_Key: null,
      AuthenHeaderName: null,
      Show_API_Key: false,
      editorCursorPosition: 0,
    };
  },
  computed: {
    isViewOnly() {
      return this.$pagePermission && this.$pagePermission.isViewOnly('ModelData');
    },
    headers() {
      return [
        { title: "ID", align: "center", sortable: false, width: "60px" },
        {
          title: this.$t("Provider"),
          align: "center",
          sortable: true,
          value: "provider",
          width: "120px",
        },
        {
          title: this.$t("Display Name"),
          align: "center",
          sortable: true,
          value: "modelDisplay",
          width: "auto",
        },
        {
          title: this.$t("modelName"),
          align: "center",
          sortable: true,
          value: "modelName",
          width: "auto",
        },
        {
          title: "API Version",
          align: "center",
          sortable: true,
          value: "apiVersion",
          width: "120px",
        },
        {
          title: "Model Type",
          align: "center",
          sortable: true,
          value: "modelType",
          width: "170px",
        },
        {
          title: "Price",
          align: "center",
          sortable: false,
          value: "price",
          width: "120px",
        },
        {
          title: this.$t("Actions"),
          align: "center",
          sortable: false,
          width: "120px",
        },
      ];
    },
  },
  async mounted() {
    let self = this;
    self.GetDate();
    await self.GetKeyJSON();
    await self.GetProviderData();
  },
  watch: {
    options: {
      handler() {
        this.GetModelData();
      },
      deep: true,
    },
    CurrentPromptPrice: {
      handler: function (newVal, oldVal) {
        let regex = /^\d*\.?\d*$/;
        if (!regex.test(newVal) && newVal != null && newVal != "") {
          this.$nextTick(() => {
            this.CurrentPromptPrice = oldVal;
          });
        }
      },
      deep: true,
    },
    CurrentCompletionPrice: {
      handler: function (newVal, oldVal) {
        let regex = /^\d*\.?\d*$/;
        if (!regex.test(newVal) && newVal != null && newVal != "") {
          this.$nextTick(() => {
            this.CurrentCompletionPrice = oldVal;
          });
        }
      },
      deep: true,
    },
    CurrentImagePrice: {
      handler: function (newVal, oldVal) {
        let regex = /^\d*\.?\d*$/;
        if (!regex.test(newVal) && newVal != null && newVal != "") {
          this.$nextTick(() => {
            this.CurrentImagePrice = oldVal;
          });
        }
      },
      deep: true,
    },
  },
  methods: {
    preventNegative(e) {
      if (e.key === '-' || e.key === 'Subtract' || e.key === '.' || e.key === ',') {
        e.preventDefault();
      }
    },
    onDragOver(event) {
      // event.preventDefault();
      event.dataTransfer.dropEffect = "copy";
    },

    onDragLeave(event) {
      event.preventDefault();
      this.dragCounter--;
      if (this.dragCounter === 0) {
        this.isDragOver = false;
      }
    },
    insertTextAtCursor(text) {
      // Get the active editor based on which dialog is open
      const editor = this.AdddialogUser ? this.$refs.addJsonEditor : this.$refs.editJsonEditor;
      
      if (!editor) {
        // Fallback: insert at the end if no editor ref
        this.JSON_Format += text;
        return;
      }

      // Get the textarea element from the prism editor
      const textarea = editor.$el.querySelector('textarea');
      
      if (!textarea) {
        this.JSON_Format += text;
        return;
      }

      const cursorPos = textarea.selectionStart || 0;
      const before = this.JSON_Format.substring(0, cursorPos);
      const after = this.JSON_Format.substring(cursorPos);
      this.JSON_Format = before + text + after;
      
      // Update cursor position to after inserted text
      this.$nextTick(() => {
        const newPos = cursorPos + text.length;
        textarea.focus();
        textarea.setSelectionRange(newPos, newPos);
      });
    },
    updateCursorPosition(position) {
      console.log("Cursor position updated to:", position);
      this.editorCursorPosition = position;
    },
    getProviderIcon(provider) {
      const icons = {
        OpenAI: "custom:openai",
        Google: "custom:google",
        Anthropic: "custom:anthropic",
        Azure: "mdi-microsoft-azure",
        AWS: "custom:aws",
        Other: "mdi-cloud",
      };
      return icons[provider] || "mdi-cloud";
    },

    getProviderColor(provider) {
      const colors = {
        OpenAI: "black",
        Google: "#4285F4",
        Anthropic: "#D4A27F",
        Azure: "primary",
        AWS: "#FF9900",
        Other: "grey",
      };
      return colors[provider] || "grey";
    },

    getModelTypeClass(modelType) {
      return modelType === "text_based" ? "text-based" : "text-to-image";
    },
    GetDate() {
      let today1 = new Date();
      let dd = today1.getDate();
      let mm = today1.getMonth() + 1; //January is 0!

      let yyyy = today1.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }

      this.today = dd + "/" + mm + "/" + yyyy;
    },
    async GetProviderData() {
      let self = this;
      self.dialog = true;
      await self.$call.GetDDLProviderData(
        async (dataResponse) => {
          if (dataResponse.status == 0) {
            self.DDProvider = dataResponse.data;
          } else {
            self.DDProvider = [];
          }
          self.dialog = false;
        },
        (errorResource) => {
          self.dialog = false;
          console.error(errorResource);
        }
      );
    },
    async GetModelData() {
      try {
        let self = this;
        self.dialog = true;

        let { page, itemsPerPage, sortBy } = self.options;
        let sortField = null;
        let sortOrder = null;

        if (sortBy && sortBy.length > 0) {
          sortField = sortBy[0].key;
          sortOrder = sortBy[0].order === "desc";
        }
        let temp = {
          page: self.isSearch ? 1 : page,
          perPage: itemsPerPage != -1 ? itemsPerPage : self.totalTable,
          sortDesc: sortOrder,
          sortBy: sortField,
        };
        await self.$call.GetModelData(
          temp,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              self.listDataModel = dataResponse.data.data.map(
                (items, index) => ({
                  ...items,
                  key: index + 1,
                  completionPriceUSD: parseFloat(
                    items.completionPriceUSD || 0
                  ).toFixed(6),
                  promptPriceUSD: parseFloat(items.promptPriceUSD || 0).toFixed(
                    6
                  ),
                  imagePriceUSD: parseFloat(items.imagePriceUSD || 0).toFixed(
                    6
                  ),
                })
              );
              self.totalTable = self.isFirst
                ? dataResponse.data.total
                : self.totalTable;
              self.searchTotalTable = dataResponse.data.total;
            } else {
              self.listDataModel = [];
              self.totalTable = 0;
              self.searchTotalTable = 0;
            }
            self.dialog = false;
            self.isFirst = false;
          },
          (errorResource) => {
            self.dialog = false;
            if (errorResource.status != 0) {
              console.error(errorResource);
            }
          }
        );
      } catch (error) {
        // this.LogTrace(error, "Apply");
      }
    },

    async AddModelData() {
      try {
        let self = this;
        if (
          (self.CurrentCompletionPrice == null || self.CurrentCompletionPrice.trim() == '') ||
          (self.CurrentPromptPrice == null || self.CurrentPromptPrice.trim() == '') 
        ) {
          if (self.CurrentCompletionPrice == null || self.CurrentCompletionPrice.trim() == '') {
            self.errorMessage.CurrentCompletionPrice.error = true;
            self.errorMessage.CurrentCompletionPrice.message = 'Required';
          }
          if (self.CurrentPromptPrice == null || self.CurrentPromptPrice.trim() == '') {
            self.errorMessage.CurrentPromptPrice.error = true;
            self.errorMessage.CurrentPromptPrice.message = 'Required';
          }
          return;
        }
        if (
          self.currentModelName != null &&
          self.currentModelName.trim() != "" &&
          ((self.currentAPIVesion != null &&
            self.currentAPIVesion.trim() != "" &&
            self.currentProvider != "Google" &&
            self.currentProvider != "Other" &&
            self.currentProvider != "OpenAI") ||
            self.currentProvider == "Google" ||
            self.currentProvider == "Other" ||
            self.currentProvider == "OpenAI") &&
          ((self.currentModelDisplay != null &&
            self.currentModelDisplay.trim() != "" &&
            self.currentProvider != "Other") ||
            self.currentProvider == "Other") &&
          self.currentProvider != null &&
          self.currentProvider.trim() != "" &&
          ((self.currentProvider == "Other" &&
            self.EndPointURL != null &&
            self.EndPointURL.trim() != "") ||
            self.currentProvider != "Other") &&
          ((self.currentProvider == "Other" &&
            self.AuthenHeaderName != null &&
            self.AuthenHeaderName.trim() != "" &&
            self.API_Key != null &&
            self.API_Key.trim() != "") ||
            self.currentProvider != "Other") &&
            self.CurrentPromptPrice != '' &&
            self.CurrentCompletionPrice != ''
        ) {
          if (
            self.currentProvider == "Other" &&
            (self.JSON_Format == null ||
              self.JSON_Format.trim() == "" ||
              !self.isValidJson(self.JSON_Format))
          ) {
            self.$swal.fire({
              icon: "warning",
              title: self.$t("warning"),
              text: self.$t("_WarningJSONFormat"),
              showConfirmButton: false,
              timer: 1800,
            });
            return;
          }
          self.dialog = true;
          let temp = {
            ModelName:
              self.currentModelName != null ? self.currentModelName.trim() : "",
            APIVersion:
              self.currentAPIVesion != null ? self.currentAPIVesion.trim() : "",
            ModelDisplay: self.currentModelDisplay.trim(),
            Provider: self.currentProvider.trim(),
            EndPointURL:
              self.EndPointURL != null ? self.EndPointURL.trim() : "",
            AuthenHeaderName:
              self.AuthenHeaderName != null ? self.AuthenHeaderName.trim() : "",
            API_Key: self.API_Key != null ? self.API_Key.trim() : "",
            UseUploadFile: self.UseUploadFile,
            UseReasoningEffort: self.UseReasoningEffort,
            modelType: self.currentModelType,
            completionPrice: null,
            promptPrice: null,
            imagePriceUSD: null,
            quality: null,
            resolution: null,
            JsonRequest: self.JSON_Format,
            maxToken: self.maxToken == "" ? 4096 : self.maxToken,
          };
          if (self.currentModelType === "text_to_image") {
            temp.imagePriceUSD = parseFloat(self.CurrentImagePrice).toFixed(6);
            temp.quality = self.currentQuality;
            temp.resolution = self.currentResolution;
          } else {
            temp.completionPrice = self.CurrentCompletionPrice
            // parseFloat(
            //   self.CurrentCompletionPrice
            // ).toFixed(6)
            //parseFloat(self.CurrentPromptPrice).toFixed(6)
            temp.promptPrice = self.CurrentPromptPrice;
          }
          await self.$call.CreateModelData(
            temp,
            (dataResponse) => {
              if (dataResponse.status == 0) {
                self.dialog = false;
                if (dataResponse.data == "Data is duplicate") {
                  self.$swal.fire({
                    icon: "warning",
                    title: self.$t("warning"),
                    text: dataResponse.data,
                    showConfirmButton: false,
                    timer: 1800,
                  });
                } else {
                  self.$swal.fire({
                    icon: "success",
                    title: dataResponse.message,
                    showConfirmButton: false,
                    timer: 1500,
                    allowOutsideClick: true,
                    allowEscapeKey: true,
                    allowEnterKey: true,
                    backdrop: false 
                  });
                  self.AdddialogUser = false;
                  self.totalTable = self.totalTable + 1;
                  self.GetModelData();
                }
              } else {
                self.AdddialogUser = false;
                self.dialog = false;
              }
            },
            (errorResource) => {
              console.log(errorResource);
              self.dialog = false;
              if (errorResource.status != 0) {
                console.error(errorResource);
              }
            }
          );
        } else {
          self.$swal.fire({
            icon: "warning",
            title: self.$t("warning"),
            text: self.$t("pleasefillininformation"),
            showConfirmButton: false,
            timer: 1800,
          });
        }
      } catch (error) {
        // this.LogTrace(error, "Apply");
      }
    },
    async UpdateModelData() {
      try {
        let self = this;

        if (
          (self.CurrentCompletionPrice == null || self.CurrentCompletionPrice.trim() == '') ||
          (self.CurrentPromptPrice == null || self.CurrentPromptPrice.trim() == '')
        ) {
          if (self.CurrentCompletionPrice == null || self.CurrentCompletionPrice.trim() == '') {
            self.errorMessage.CurrentCompletionPrice.error = true;
            self.errorMessage.CurrentCompletionPrice.message = 'Required';
          }
          if (self.CurrentPromptPrice == null || self.CurrentPromptPrice.trim() == '') {
            self.errorMessage.CurrentPromptPrice.error = true;
            self.errorMessage.CurrentPromptPrice.message = 'Required';
          }
          return;
        }
        if (
          self.currentModelName != null &&
          self.currentModelName.trim() != "" &&
          ((self.currentAPIVesion != null &&
            self.currentAPIVesion.trim() != "" &&
            self.currentProvider != "Google" &&
            self.currentProvider != "Other" &&
            self.currentProvider != "OpenAI") ||
            self.currentProvider == "Google" ||
            self.currentProvider == "Other" ||
            self.currentProvider == "OpenAI") &&
          ((self.currentModelDisplay != null &&
            self.currentModelDisplay.trim() != "" &&
            self.currentProvider != "Other") ||
            self.currentProvider == "Other") &&
          self.currentProvider != null &&
          self.currentProvider.trim() != "" &&
          ((self.currentProvider == "Other" &&
            self.EndPointURL != null &&
            self.EndPointURL.trim() != "") ||
            self.currentProvider != "Other") &&
          ((self.currentProvider == "Other" &&
            self.AuthenHeaderName != null &&
            self.AuthenHeaderName.trim() != "" &&
            self.API_Key != null &&
            self.API_Key.trim() != "") ||
            self.currentProvider != "Other")
        ) {
          if (
            self.currentProvider == "Other" &&
            (self.JSON_Format == null ||
              self.JSON_Format.trim() == "" ||
              !self.isValidJson(self.JSON_Format))
          ) {
            self.$swal.fire({
              icon: "warning",
              title: self.$t("warning"),
              text: self.$t("_WarningJSONFormat"),
              showConfirmButton: false,
              timer: 1800,
            });
            return;
          }
          let chkdup = self.listDataModel.filter(
            (e) =>
              e.id != self.currentID && e.modelName == self.currentModelName && e.provider == self.currentProvider
          );
          if (chkdup.length == 0) {
            self.dialog = true;
            let temp = {
              id: self.currentID,
              ModelName:
                self.currentModelName != null
                  ? self.currentModelName.trim()
                  : "",
              APIVersion:
                self.currentAPIVesion != null
                  ? self.currentAPIVesion.trim()
                  : "",
              ModelDisplay: self.currentModelDisplay.trim(),
              Provider: self.currentProvider.trim(),
              AuthenHeaderName:
                self.AuthenHeaderName != null
                  ? self.AuthenHeaderName.trim()
                  : "",
              EndPointURL:
                self.EndPointURL != null ? self.EndPointURL.trim() : "",
              API_Key: self.API_Key != null ? self.API_Key.trim() : "",
              UseUploadFile: self.UseUploadFile,
              UseReasoningEffort: self.UseReasoningEffort,
              modelType: self.currentModelType,
              completionPrice: null,
              promptPrice: null,
              imagePriceUSD: null,
              quality: null,
              resolution: null,
              JsonRequest: self.JSON_Format,
              maxToken: self.maxToken == "" ? 4096 : self.maxToken,
            };

            if (self.currentModelType === "text_to_image") {
              temp.imagePriceUSD = parseFloat(self.CurrentImagePrice).toFixed(
                6
              );
              temp.quality = self.currentQuality;
              temp.resolution = self.currentResolution;
            } else {
              temp.completionPrice = parseFloat(
                self.CurrentCompletionPrice
              ).toFixed(6);
              temp.promptPrice = parseFloat(self.CurrentPromptPrice).toFixed(6);
            }
            await self.$call.UpdateModelData(
              temp,
              (dataResponse) => {
                if (dataResponse.status == 0) {
                  if (dataResponse.data == "Data is duplicate") {
                    self.$swal.fire({
                      icon: "warning",
                      title: self.$t("warning"),
                      text: dataResponse.data,
                      showConfirmButton: false,
                      timer: 1800,
                    });
                  } else {
                    self.$swal.fire({
                      icon: "success",
                      title: dataResponse.message,
                      showConfirmButton: false,
                      timer: 1500,
                    });
                    self.EditdialogUser = false;
                    self.dialog = false;
                    self.GetModelData();
                  }
                } else {
                  self.$swal.fire({
                    icon: "error",
                    title: dataResponse.message,
                    showConfirmButton: false,
                    timer: 1800,
                  });
                  self.EditdialogUser = false;
                  self.dialog = false;
                  self.GetModelData();
                }
                self.dialog = false;
                self.isFirst = false;
              },
              (errorResource) => {
                self.dialog = false;
                if (errorResource.status != 0) {
                  console.error(errorResource);
                }
              }
            );
          } else {
            self.EditdialogUser = false;
            self.dialog = false;
          }
        } else {
          self.$swal.fire({
            icon: "warning",
            title: self.$t("warning"),
            text: self.$t("pleasefillininformation"),
            showConfirmButton: false,
            timer: 1800,
          });
          return;
        }
      } catch (error) {
        // this.LogTrace(error, "Apply");
      }
    },
    async DeleteModelData() {
      try {
        let self = this;
        self.$swal
          .fire({
            title: this.$t("confirmDeletion"),
            text: this.$t("confirmDeletionModel"),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: this.$t("confirm"),
            cancelButtonText: this.$t("cancel"),
            reverseButtons: false,
          })
          .then((result) => {
            if (result.isConfirmed) {
              self.dialog = true;
              let temp = {
                id: self.currentID,
              };
              self.$call.DeleteModelData(
                temp,
                (dataResponse) => {
                  if (dataResponse.status == 0) {
                    self.$swal.fire({
                      icon: "success",
                      title: dataResponse.message,
                      showConfirmButton: false,
                      timer: 1800,
                    });
                    self.dialog = false;
                    self.GetModelData();
                  } else {
                    self.$swal.fire({
                      icon: "error",
                      title: dataResponse.message,
                      showConfirmButton: false,
                      timer: 1800,
                    });
                    self.dialog = false;
                    self.GetModelData();
                  }
                  self.dialog = false;
                  self.isFirst = false;
                },
                (errorResource) => {
                  self.dialog = false;
                  if (errorResource.status != 0) {
                    console.error(errorResource);
                  }
                }
              );
            }
          });
      } catch (error) {
        // this.LogTrace(error, "Apply");
      }
    },
    Add() {
      let self = this;
      self.AdddialogUser = true;
      self.currentModelName = "";
      self.currentAPIVesion = "";
      self.CurrentCompletionPrice = "";
      self.CurrentPromptPrice = "";
      self.currentModelDisplay = "";
      self.currentProvider = "";
      self.currentModelType = "";
      self.UseUploadFile = false;
      self.UseReasoningEffort = false;
      // Reset new fields
      self.CurrentImagePrice = 0;
      self.currentQuality = "";
      self.currentResolution = "";
      self.JSON_Format = `{
  "messages":"{messages}"
}`;
      self.EndPointURL = null;
      self.AuthenHeaderName = null;
      self.API_Key = null;
      self.Show_API_Key = false;
    },
    Edit(item) {
      let self = this;
      self.EditdialogUser = true;
      self.currentModelName = item.modelName;
      self.currentAPIVesion = item.apiVersion;
      self.CurrentCompletionPrice = item.completionPriceUSD;
      self.CurrentPromptPrice = item.promptPriceUSD;
      self.currentModelDisplay = item.modelDisplay;
      self.currentProvider = item.provider;
      self.currentModelType = item.modelType;
      self.UseUploadFile = item.useUploadFile;
      self.UseReasoningEffort = item.useReasoningEffort;
      self.currentID = item.id;
      // Set new fields if available, else default
      self.CurrentImagePrice = item.imagePriceUSD || 0;
      self.currentQuality = item.quality || "";
      self.currentResolution = item.resolution || "";
      self.JSON_Format = item.jsonRequest || "";
      self.EndPointURL = item.endPointURL || "";
      self.AuthenHeaderName = item.authenHeaderName || "";
      self.API_Key = item.apI_Key || "";
      self.Show_API_Key = false;
      self.maxToken = item.maxToken
    },
    Delete(item) {
      let self = this;
      self.currentModelName = item.modelName;
      self.currentID = item.id;
      self.DeleteModelData();
      // console.log(self.currentID)
    },
    Close() {
      let self = this;

      self.errorMessage = {
        CurrentPromptPrice: {
          error: false,
          message: ''
        },
        CurrentCompletionPrice: {
          error: false,
          message: ''
        },
      };

      self.AdddialogUser = false;
      self.EditdialogUser = false;
      self.statusDialog = false;
      self.currentModelName = "";
      self.currentID = null;
      self.CurrentCompletionPrice = "";
      self.CurrentPromptPrice = "";
      self.UseUploadFile = false;
      self.UseReasoningEffort = false;
      self.maxToken = ""
    },
    CloseStatusDialog() {
      let self = this;
      self.statusDialog = false;
    },
    async GetKeyJSON() {
      let self = this;
      self.dialog = true;
      await self.$call.GetKeyJSON(
        async (dataResponse) => {
          if (dataResponse.status == 0) {
            // console.table(dataResponse.data)
            self.menuKeyJSON = dataResponse.data;
          } else {
            self.menuKeyJSON = [];
          }
          self.dialog = false;
        },
        (errorResource) => {
          self.dialog = false;
          console.error(errorResource);
        }
      );
    },
    highlighter(code) {
      return highlight(code, languages.js);
    },
    onDrop(event) {
      // event.preventDefault();
      const text = event.dataTransfer.getData("text");
      this.code += text;
    },
    onDragStart(event, text) {
      event.dataTransfer.setData("text", text);
    },
    showPopup() {
      this.showClipboardPopup = true;
      setTimeout(() => {
        this.showClipboardPopup = false;
      }, 2000);
    },
    changeProvider(Provider) {
      var self = this;
      if (Provider == "Other") {
        self.currentModelName = null;
        self.currentAPIVesion = null;
      } else if (Provider == "OpenAI") {
        self.currentAPIVesion = null;
        self.EndPointURL = null;
        self.AuthenHeaderName = null;
        self.API_Key = null;
      } else {
        self.EndPointURL = null;
        self.AuthenHeaderName = null;
        self.API_Key = null;
      }
    },
    isValidJson(jsonString) {
      try {
        JSON.parse(jsonString);
        return true;
      } catch (e) {
        return false;
      }
    },
  },
};
</script>
<style scoped>
.card2 {
  border-radius: 10px !important;
  margin-bottom: 2rem;
}

.flex {
  margin-left: 2rem;
  margin-right: 2rem;
}

/* Add these styles to your component */
/* .model-dialog {
  border-radius: 8px;
}

.dialog-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
} */

.section-title {
  font-size: 1.1rem;
  font-weight: 500;
  color: var(--v-primary-base);
  padding-bottom: 8px;
  border-bottom: 2px solid var(--v-primary-base);
}

::v-deep .v-data-table-server__wrapper th {
  white-space: nowrap;
  vertical-align: middle;
}

::v-deep .v-data-table-server__wrapper__wrapper th span {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.rounded-lg {
  border-radius: 8px;
}

.fade-up-enter-active,
.fade-up-leave-active {
  transition: all 0.4s ease;
  max-height: 500px;
  overflow: hidden;
}

.fade-up-enter,
.fade-up-leave-to {
  opacity: 0;
  max-height: 0;
  padding: 0;
  margin: 0;
}

.fade-up-enter-to,
.fade-up-leave {
  opacity: 1;
  max-height: 500px;
}

.price-container {
  display: flex;
  align-items: center;
  padding: 4px 8px;
  border-radius: 4px;
  /* background-color: rgba(0, 0, 0, 0.03); */
}

.price-content {
  display: flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
}

.input-section,
.output-section {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.input-section {
  color: var(--v-success-base);
}

.output-section {
  color: var(--v-info-base);
}

.divider {
  color: rgba(0, 0, 0, 0.6);
  margin: 0 4px;
}

.caption {
  font-size: 0.75rem;
  color: rgba(0, 0, 0, 0.6);
}

.image-section {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: var(--v-purple-base);
}
.my-editor {
  background: #2d2d2d;
  color: #ccc;
  min-height: 45px;
  font-family: Fira code, Fira Mono, Consolas, Menlo, Courier, monospace;
  font-size: 14px;
  line-height: 1.5;
  padding: 5px;
  padding-top: 10px;
  padding-bottom: 10px;
  border-radius: 10px 10px 10px 10px;
}

.draggable-box {
  background-color: #5179ef;
  border-radius: 5px;
  border: 1px solid #5179ef;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-weight: 500;
  font-family: "Roboto", sans-serif;
  font-size: 14px;
  cursor: pointer;
  user-select: none;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s, box-shadow 0.2s;
  margin-bottom: 6px;
  padding: 3px;
  padding-left: 12px;
  padding-right: 12px;
  letter-spacing: 1px; /* เพิ่มช่องไฟระหว่างตัวอักษร */
  line-height: 1.6; /* เพิ่มความสูงของบรรทัด */
}

.draggable-box:hover {
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
  background-color: #45a049;
  border: 1px solid #45a049;
  color: #fff;
}

.areaDrag {
  border: 1px solid #2d2d2d;
  border-radius: 40px 0px 0px 0px;
  padding-top: 3px;
  background: #2d2d2d;
}

#JSONFormat {
  border-radius: 10px 10px 10px 10px;
  display: grid;
  grid-template-rows: auto 1fr;
}

#JSONFormat .v-speed-dial {
  position: absolute;
}

#JSONFormat .v-btn--floating {
  position: relative;
}

.scrollable-content {
  max-height: 250px !important;
  overflow-y: auto !important;
  display: flex !important;
  flex-direction: column !important;
  align-items: flex-end !important;
  padding-right: 150px !important;
}
.my-editor.is-invalid {
  border: 3px solid red;
  border-radius: 4px;
}
.model-data-container {
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  padding: 24px;
}

/* Header */
.page-header {
  margin-bottom: 32px;
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: white;
  padding: 28px 32px;
  border-radius: 20px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08);
}

.header-left {
  display: flex;
  align-items: center;
  gap: 20px;
}

.header-icon {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 16px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 8px 24px rgba(102, 126, 234, 0.3);
}

.page-title {
  font-size: 2rem;
  font-weight: 700;
  color: #1e293b;
  margin: 0 0 6px 0;
  line-height: 1.2;
}

.page-subtitle {
  color: #64748b;
  margin: 0;
  font-size: 1rem;
  line-height: 1.4;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 24px;
}

.stats-card {
  background: #f8fafc;
  padding: 16px 24px;
  border-radius: 12px;
  text-align: center;
  border: 1px solid #e2e8f0;
}

.stat-value {
  font-size: 1.5rem;
  font-weight: 700;
  color: #1e293b;
  line-height: 1;
}

.stat-label {
  font-size: 0.75rem;
  color: #64748b;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.date-display {
  display: flex;
  align-items: center;
  color: #64748b;
  font-weight: 500;
}

/* Main Card */
.main-card {
  background: white;
  border-radius: 20px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

/* Action Bar */
.action-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 32px;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  border-bottom: 1px solid #e2e8f0;
}

.search-section {
  flex: 1;
  max-width: 400px;
  margin-right: 24px;
}

.search-input >>> .v-field {
  border-radius: 12px;
  background: white;
}

.add-button {
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
  border-radius: 12px;
  text-transform: none;
  font-weight: 600;
}

.add-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(102, 126, 234, 0.6);
}

/* Table */
.table-container {
  padding: 0;
}

.modern-table {
  background: transparent;
}

.modern-table >>> .v-data-table-server__wrapper__wrapper {
  border-radius: 0;
}

.modern-table >>> thead tr {
  background: #f8fafc;
}

.modern-table >>> thead th {
  color: #475569 !important;
  font-weight: 600;
  padding: 20px 16px;
  border-bottom: 2px solid #e2e8f0;
  font-size: 0.875rem;
  letter-spacing: 0.5px;
}

.table-row {
  transition: all 0.2s ease;
  border-bottom: 1px solid #f1f5f9;
}

.table-row:hover {
  background: #f8fafc;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.table-row td {
  padding: 16px;
  vertical-align: middle;
}

.row-number {
  background: #e2e8f0;
  color: #64748b;
  padding: 4px 8px;
  border-radius: 6px;
  font-weight: 600;
  font-size: 0.8125rem;
}

/* Provider Cell */
.provider-cell {
  display: flex;
  align-items: center;
  gap: 12px;
}

.provider-icon {
  background: #f1f5f9;
  padding: 8px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.provider-name {
  font-weight: 600;
  color: #374151;
}

/* Model Display */
.model-display {
  display: flex;
  align-items: center;
  gap: 12px;
}

.model-name {
  font-weight: 600;
  color: #1f2937;
}

.model-badge {
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.model-badge.text-based {
  background: #dcfce7;
  color: #166534;
}

.model-badge.text-to-image {
  background: #fef3c7;
  color: #92400e;
}

/* Model Code */
.model-code {
  background: #f1f5f9;
  color: #475569;
  padding: 6px 10px;
  border-radius: 6px;
  font-family: "Monaco", "Consolas", monospace;
  font-size: 0.8125rem;
  border: 1px solid #e2e8f0;
}

/* API Version */
.api-version {
  background: #e0e7ff;
  color: #3730a3;
  padding: 4px 8px;
  border-radius: 6px;
  font-weight: 600;
  font-size: 0.8125rem;
}

/* Model Type Badge */
.model-type-badge {
  display: inline-flex;
  align-items: center;
  padding: 6px 12px;
  border-radius: 20px;
  font-weight: 600;
  font-size: 0.8125rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.model-type-badge.text-based {
  background: #dcfce7;
  color: #166534;
}

.model-type-badge.text-to-image {
  background: #fef3c7;
  color: #92400e;
}

/* Price Display */
.price-display {
  min-width: 140px;
}

.price-row {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 4px;
}

.price-item {
  display: flex;
  align-items: center;
  gap: 6px;
  font-weight: 600;
  font-size: 0.8125rem;
}

.price-item.input {
  color: #059669;
}

.price-item.output {
  color: #0ea5e9;
}

.price-item.image {
  color: #7c3aed;
}

.price-unit {
  font-size: 0.6875rem;
  color: #64748b;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* Dialog Styles */
/* .modern-dialog >>> .v-overlay__content {
  border-radius: 20px;
  overflow: hidden;
} */

/* Dialog Header */

/* .dialog-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #111827;
  margin: 0 0 8px 0;
  line-height: 1.3;
}

.dialog-subtitle {
  font-size: 0.9375rem;
  color: #6b7280;
  margin: 0;
  line-height: 1.5;
}

.close-button {
  color: #9ca3af !important;
  background: #f9fafb !important;
  border: 1px solid #e5e7eb;
  border-radius: 8px !important;
} */

/* Dialog Content */
.dialog-body {
  padding: 32px;
  max-height: 70vh;
  overflow-y: auto;
}

/* Form Sections */
.form-section {
  margin-bottom: 32px;
}

.section-title {
  display: flex;
  align-items: center;
  font-size: 1.125rem;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 20px;
  padding-bottom: 8px;
  border-bottom: 2px solid #e5e7eb;
}

.section-title.expandable {
  cursor: pointer;
  transition: all 0.2s ease;
  justify-content: space-between;
}

.section-title.expandable:hover {
  color: #3b82f6;
}

.expand-icon {
  transition: transform 0.3s ease;
}

.expand-icon.expanded {
  transform: rotate(180deg);
}

/* Form Grid */
.form-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
}

.form-grid .full-width {
  grid-column: 1 / -1;
}

/* Modern Input */
.modern-input >>> .v-field {
  border-radius: 12px;
  background: #fafbfc;
  transition: all 0.2s ease;
}

.modern-input >>> .v-field__outline {
  color: #d1d5db;
}

.modern-input >>> .v-field--focused .v-field__outline {
  color: #3b82f6;
  border-width: 2px;
}

.modern-input >>> .v-field--focused {
  background: white;
}

.price-suffix {
  font-size: 0.75rem;
  color: #64748b;
  margin-left: 8px;
}

/* Switch Grid */
.switch-grid {
  display: grid;
  gap: 20px;
}

.switch-item {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px;
  background: #f8fafc;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  transition: all 0.2s ease;
}

.switch-item:hover {
  background: #f1f5f9;
  border-color: #cbd5e1;
}

.switch-content {
  flex: 1;
}

.switch-title {
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 4px;
}

.switch-description {
  font-size: 0.875rem;
  color: #6b7280;
}

/* JSON Configuration */
.json-header {
  cursor: pointer;
  margin-bottom: 16px;
}

.json-info-card {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 20px;
}

.json-info-card h4 {
  color: #1f2937;
  font-weight: 600;
  margin-bottom: 12px;
}

.code-example {
  background: #1e293b;
  color: #e2e8f0;
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 16px;
  overflow-x: auto;
}

.code-example pre {
  margin: 0;
  font-family: "Monaco", "Consolas", monospace;
  font-size: 0.875rem;
  line-height: 1.5;
}

.format-notes {
  margin: 0;
  padding-left: 20px;
}

.format-notes li {
  margin-bottom: 8px;
  color: #4b5563;
  font-size: 0.875rem;
}

/* JSON Editor */
.json-editor-container {
  position: relative;
  background: #1e293b;
  border-radius: 12px;
  overflow: hidden;
  margin-bottom: 16px;
}

.json-editor {
  font-family: "Monaco", "Consolas", monospace;
  font-size: 0.875rem;
  line-height: 1.6;
  min-height: 200px;
  color: #e2e8f0;
  caret-color: #ffffff;
}

.json-editor.error {
  border: 2px solid #ef4444;
}

.json-tools {
  position: absolute;
  top: 12px;
  right: 12px;
}

.json-tool-btn {
  background: rgba(255, 255, 255, 0.1) !important;
  backdrop-filter: blur(8px);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.json-menu {
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
}

.json-menu-item {
  padding: 12px 16px;
  transition: all 0.2s ease;
}

.json-menu-item:hover {
  background: #f8fafc;
}

/* Error Message */
.error-message {
  display: flex;
  align-items: center;
  background: #fef2f2;
  color: #dc2626;
  padding: 12px 16px;
  border-radius: 8px;
  border: 1px solid #fecaca;
  font-size: 0.875rem;
}

/* Dialog Actions */
.dialog-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 24px 32px;
  background: #f8fafc;
  border-top: 1px solid #e2e8f0;
}

.cancel-btn {
  color: #6b7280 !important;
  font-weight: 500;
}

.save-btn {
  background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%) !important;
  color: white !important;
  font-weight: 600;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.4);
  border-radius: 12px !important;
  text-transform: none;
}

.save-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 20px rgba(59, 130, 246, 0.6);
}

/* Loading Overlay */
.loading-overlay >>> .v-overlay__scrim {
  background: rgba(255, 255, 255, 0.9) !important;
  backdrop-filter: blur(8px);
}

.loading-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  background: white;
  padding: 32px;
  border-radius: 16px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
}

/* Transitions */
.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: all 0.3s ease;
}

.fade-slide-enter-from {
  opacity: 0;
  transform: translateY(-10px);
}

.fade-slide-leave-to {
  opacity: 0;
  transform: translateY(10px);
}

/* Responsive Design */
@media (max-width: 1024px) {
  .form-grid {
    grid-template-columns: 1fr;
  }

  .header-content {
    flex-direction: column;
    gap: 20px;
    text-align: center;
  }

  .action-bar {
    flex-direction: column;
    gap: 16px;
  }

  .search-section {
    margin-right: 0;
    max-width: none;
  }
}

@media (max-width: 768px) {
  .model-data-container {
    padding: 16px;
  }

  .header-content {
    padding: 20px 24px;
  }

  .page-title {
    font-size: 1.5rem;
  }

  .action-bar {
    padding: 16px 20px;
  }

  .dialog-body {
    padding: 20px;
  }

  .dialog-actions {
    padding: 16px 20px;
  }

  .modern-table >>> thead th,
  .table-row td {
    padding: 12px 8px;
  }
}
.header-icon-container.edit-mode {
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
}

/* Enhanced Form Validation */
.modern-input.error >>> .v-field {
  border-color: #ef4444 !important;
}

.modern-input.error >>> .v-field__outline {
  color: #ef4444 !important;
  border-width: 2px !important;
}

/* Switch Item Enhanced */
.switch-item {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px 20px;
  background: #f8fafc;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  transition: all 0.2s ease;
  position: relative;
}

.switch-item:hover {
  background: #f1f5f9;
  border-color: #cbd5e1;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.switch-content {
  flex: 1;
  margin-right: 8px;
}

.switch-title {
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 4px;
  font-size: 0.9375rem;
}

.switch-description {
  font-size: 0.8125rem;
  color: #6b7280;
  line-height: 1.4;
}

/* Enhanced Tooltips */
.v-tooltip >>> .v-overlay__content {
  background: #1f2937 !important;
  color: white !important;
  border-radius: 8px !important;
  padding: 8px 12px !important;
  font-size: 0.8125rem !important;
  max-width: 250px !important;
  text-align: center !important;
}

/* Price Suffix Styling */
.price-suffix {
  font-size: 0.75rem;
  color: #64748b;
  font-weight: 500;
  white-space: nowrap;
}

/* Form Grid Enhancement */
.form-grid .full-width {
  grid-column: 1 / -1;
}

/* JSON Editor Enhanced */
.json-editor-container {
  position: relative;
  background: #1e293b;
  border-radius: 12px;
  overflow: hidden;
  margin-bottom: 16px;
  border: 2px solid transparent;
  transition: all 0.2s ease;
}

.json-editor-container:focus-within {
  border-color: #3b82f6;
  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.1);
}

.json-editor.error {
  background: #1e293b;
}

.json-editor-container.error {
  border-color: #ef4444;
  box-shadow: 0 0 0 4px rgba(239, 68, 68, 0.1);
}

/* Loading State for Save Button */
.save-btn.v-btn--loading {
  pointer-events: none;
}

.save-btn .v-btn__loader {
  color: white;
}

/* Enhanced Error Message */
.error-message {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  background: #fef2f2;
  color: #dc2626;
  padding: 12px 16px;
  border-radius: 8px;
  border: 1px solid #fecaca;
  font-size: 0.875rem;
  line-height: 1.4;
}

/* Form Section Spacing */
.form-section:last-child {
  margin-bottom: 0;
}

/* Dialog Content Scrollbar */
.dialog-body::-webkit-scrollbar {
  width: 8px;
}

.dialog-body::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 4px;
}

.dialog-body::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 4px;
}

.dialog-body::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

/* Enhanced Transitions */
.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.fade-slide-enter-from {
  opacity: 0;
  transform: translateY(-8px);
  max-height: 0;
  overflow: hidden;
}

.fade-slide-leave-to {
  opacity: 0;
  transform: translateY(8px);
  max-height: 0;
  overflow: hidden;
}

.fade-slide-enter-to,
.fade-slide-leave-from {
  opacity: 1;
  transform: translateY(0);
  max-height: 500px;
}

/* Dialog Responsiveness */
@media (max-width: 768px) {
  .header-info {
    gap: 16px;
  }

  .dialog-title {
    font-size: 1.25rem;
  }

  .dialog-subtitle {
    font-size: 0.875rem;
  }

  .dialog-body {
    padding: 20px 16px;
  }

  .form-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .switch-item {
    padding: 12px 16px;
  }

  .dialog-actions {
    padding: 16px;
    flex-direction: column-reverse;
    gap: 8px;
  }

  .save-btn,
  .cancel-btn {
    width: 100%;
    justify-content: center;
  }
}

@media (max-width: 640px) {
  .header-icon-container {
    padding: 12px;
  }

  .header-icon-container .v-icon {
    font-size: 20px !important;
  }

  .section-title {
    font-size: 1rem;
  }

  .json-info-card {
    padding: 16px;
  }

  .code-example {
    padding: 12px;
    font-size: 0.8125rem;
  }

  .json-tools {
    position: relative;
    top: auto;
    right: auto;
    margin-top: 12px;
    text-align: center;
  }
}

/* Focus States */
.modern-input >>> .v-field--focused {
  background: white;
  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.1);
}

.switch-item:focus-within {
  background: #f1f5f9;
  border-color: #3b82f6;
  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.1);
}

/* Loading Animation */
@keyframes pulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}

.save-btn.v-btn--loading {
  animation: pulse 1.5s ease-in-out infinite;
}

/* Success State */
.form-section.success {
  background: #f0fdf4;
  border: 1px solid #bbf7d0;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 24px;
}

.form-section.success .section-title {
  color: #166534;
}

.draggable-item {
  cursor: grab;
  transition: all 0.2s ease;
  position: relative;
}

.draggable-item:hover {
  background: #f8fafc;
  transform: translateX(4px);
}

.draggable-item:active {
  cursor: grabbing;
}

.draggable-item >>> .v-list-item__append {
  opacity: 0;
  transition: opacity 0.2s ease;
}

.draggable-item:hover >>> .v-list-item__append {
  opacity: 1;
}

/* Drop Zone Indicator */
.json-editor::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    45deg,
    transparent 25%,
    rgba(59, 130, 246, 0.1) 25%,
    rgba(59, 130, 246, 0.1) 50%,
    transparent 50%,
    transparent 75%,
    rgba(59, 130, 246, 0.1) 75%
  );
  background-size: 20px 20px;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.3s ease;
}

.json-editor.drag-over::before {
  opacity: 1;
}

/* Insert Notification */
.insert-notification {
  position: fixed;
  top: 20px;
  right: 20px;
  background: #10b981;
  color: white;
  padding: 12px 20px;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(16, 185, 129, 0.3);
  z-index: 9999;
  font-weight: 500;
  transform: translateX(0);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.insert-notification.fade-out {
  opacity: 0;
  transform: translateX(100px);
}

/* Enhanced JSON Menu */
.json-menu {
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
  max-height: 300px;
  overflow-y: auto;
}

.json-menu-item {
  padding: 12px 16px;
  transition: all 0.2s ease;
  border-left: 3px solid transparent;
}

.json-menu-item:hover {
  background: #f8fafc;
  border-left-color: #3b82f6;
}

/* Scrollbar for JSON Menu */
.json-menu::-webkit-scrollbar {
  width: 6px;
}

.json-menu::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 3px;
}

.json-menu::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 3px;
}

.json-menu::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}
.credentials-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  margin-bottom: 20px;
}

@media (max-width: 768px) {
  .credentials-row {
    grid-template-columns: 1fr;
  }
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .insert-notification {
    top: 10px;
    right: 10px;
    left: 10px;
    font-size: 0.875rem;
  }
}

.modern-table :deep(.v-table__wrapper) {
  max-height: 600px;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(25, 118, 210, 0.3) rgba(0, 0, 0, 0.05);
}

.modern-table :deep(.v-table__wrapper thead th) {
  position: sticky;
  top: 0;
  z-index: 2;
  background: rgb(var(--v-theme-surface, 255, 255, 255));
}

.modern-table :deep(.v-table__wrapper::-webkit-scrollbar) {
  width: 6px;
}

.modern-table :deep(.v-table__wrapper::-webkit-scrollbar-track) {
  background: rgba(0, 0, 0, 0.05);
}

.modern-table :deep(.v-table__wrapper::-webkit-scrollbar-thumb) {
  background: rgba(25, 118, 210, 0.3);
  border-radius: 3px;
}

.modern-table :deep(.v-table__wrapper::-webkit-scrollbar-thumb:hover) {
  background: rgba(25, 118, 210, 0.5);
}
</style>
